/**
 * MobileCameraPreview — shows a live webcam feed in a 16/9 card on mobile
 * Extracted from PrimateVisionV2.tsx (PRI-291 Phase 5)
 */
import { useRef, useEffect } from 'react'

export function MobileCameraPreview({ stream, isFrontCamera = false }: { stream: MediaStream; isFrontCamera?: boolean }) {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  useEffect(() => {
    const el = videoRef.current
    if (!el) return
    el.srcObject = stream
    el.muted = true
    el.play().catch(() => {})
  }, [stream])
  return (
    // PRI-494 (2026-07-29, Matt: "Rounded edges"): borderRadius removed — the
    // viewfinder zone is edge-to-edge in the Option A mockup. The old radius:12
    // let the zone's black background peek through at all four corners.
    <div style={{
      width: '100%', overflow: 'hidden',
      aspectRatio: '16/9', background: '#09090D',
      animation: 'pv2-fade-up 300ms ease both',
    }}>
      <video
        ref={videoRef}
        playsInline
        muted
        style={{
          width: '100%', height: '100%',
          objectFit: 'cover',
          transform: isFrontCamera ? 'scaleX(-1)' : 'none', // mirror only front-facing camera (selfie view)
          display: 'block',
        }}
        {...({ 'webkit-playsinline': 'true' } as React.HTMLAttributes<HTMLVideoElement>)}
      />
    </div>
  )
}
